const defaultTheme = {
  primaryColor: '#00008f',
  onPrimaryColor: '#fff',
  darkPrimaryColor: 'rgb(51, 51, 51)',
  secondaryColor: '#ef4d29',
  onSecondaryColor: '#fff',
  darkSecondaryColor: '#dd5734',
  colorButtonDisabled: '#ccc',
  backGroundColorButtonDisabled: '#ccc',
  onColorButtonDisabled: '#fff',
  textColor: '#333333',
  summaryFieldTitleColor: '#7f7f7f',
  statusColor: '#f07662',
  specialBannerBorderBottom: '#ec4d33',
  backgroundBaseDisabled: '#f0f0f0',
  backgroundBasePrimary: '#fcfcfc',
  backgroundBaseQuaternary: '#ffffff',
  backgroundBaseSecondary: '#fafafa',
  backgroundButtonLightDefault: '#ffffff',
  backgroundButtonLightDisabled: '#f0f0f0',
  backgroundButtonLightFocus: '#ffffff',
  backgroundButtonLightHover: '#e5e5e5',
  backgroundButtonPrimaryDefault: '#00008f',
  backgroundButtonPrimaryDisabled: '#f0f0f0',
  backgroundButtonPrimaryFocus: '#00008f',
  backgroundButtonPrimaryHover: '#1f1f9c',
  backgroundButtonSecondaryDefault: '#d24723',
  backgroundButtonSecondaryDisabled: '#f0f0f0',
  backgroundButtonSecondaryFocus: '#d24723',
  backgroundButtonSecondaryHover: '#d75d3d',
  backgroundFooter: '#4976ba',
  backgroundStatusPrimary: '#efeff8',
  backgroundStatusQuaternary: '#e7f3eb',
  backgroundStatusQuinary: '#fff8e7',
  backgroundStatusSecondary: '#fcf1ee',
  basicPrimary: '#ffffff',
  basicQuartenary: '#4976ba',
  basicQuinary: '#138636',
  basicSeptenary: '#ffbc11',
  borderDefault: '#cccccc',
  borderPrimaryDefault: '#00008f',
  brandPrimary_1: '#00008f',
  brandPrimary_2: '#1f1f9c',
  brandSecondary_1: '#d24723',
  brandSecondary_2: '#d75d3d',
  focusLight: '#FFFFFF',
  focusPrimary: '#00008F',
  focusSecondary: '#d24723',
  iconAction_1: '#343c3d',
  iconAction_2: '#cccccc',
  iconAction_3: '#ffbc11',
  iconAction_4: '#138636',
  iconAction_5: '#4976ba',
  iconAction_7: '#343c3d',
  iconDefaultPrimary: '#00008f',
  iconDefaultSecondary: '#d24723',
  iconOnColor: '#ffffff',
  innerShadowDisabled: '#e5e5e5',
  innerShadowDivider: '#f0f0f0',
  innerShadowLight: '#e5e5e5',
  innerShadowPrimary: '#00006d',
  innerShadowSecondary: '#b03c1d',
  shadowColor: '#000000',
  shadowSmall: '#000000',
  textBasicPrimary: '#4976ba',
  textButtonPrimary: '#FFFFFF',
  textButtonSecondary: '#FFFFFF',
  textDisabled: '#757575',
  textFooter: '#ffffff',
  textOnColor_1: '#ffffff',
  textOnColor_2: '#cccccc',
  textOnColor_3: '#E5E5E5',
  textPrimary: '#343C3D',
  textQuaternaryDefault: '#d24723',
  textQuaternaryHover: '#d75d3d',
  textSecondary: '#5f5f5f',
  textSuccess: '#138636',
  textTertiary: '#00008f',
  textTertiaryDefault: '#00008f',
  textTertiaryHover: '#1f1f9c',
};

export default defaultTheme;
